/**
 * Вкладка «Подбор» карточки сделки (и блок карточки лида): что отправляли в салон на подбор по
 * фото клиента и что там ответили. Спека `docs/specs/2026-10-07-chat-podbor-design.md`;
 * те же данные — `prokat-runner chat-podbor --deal ID`.
 */
import { useQuery } from "@tanstack/react-query";

import { PodborList } from "@/components/chat/Podbor";
import { loadDealPodbor, loadLeadPodbor } from "@/lib/podbor";

export function DealPodborTab({ dealId }: { dealId: number }) {
  const q = useQuery({ queryKey: ["deal-podbor", dealId], queryFn: () => loadDealPodbor(dealId), refetchInterval: 30000 });
  if (q.isPending) return <div className="text-[12.5px] text-fg-muted">Смотрю запросы на подбор…</div>;
  if (q.isError) return <div className="text-[12.5px] text-err">Не удалось открыть подбор: {String(q.error.message)}</div>;
  return <PodborList rows={q.data.rows} />;
}

/** В карточке лида вкладок нет — блок показываем, только когда запросы есть. */
export function LeadPodbor({ leadId }: { leadId: number }) {
  const q = useQuery({ queryKey: ["lead-podbor", leadId], queryFn: () => loadLeadPodbor(leadId) });
  if (!q.data?.rows.length) return null;
  return (
    <section data-annot="подбор лида">
      <div className="mb-1 text-[13px] font-medium">Подбор по фото клиента</div>
      <PodborList rows={q.data.rows} />
    </section>
  );
}
